import { userTypes } from "../constants";

const formatDate = (date) => {
    const options = { weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' };
    return date.toLocaleDateString('sv-SE', options);
};

const formatShortDate = (date, type = null, lang = 'sv-SE') => {
    
    // Om date skickas som en string och inte en Date
    if (typeof date === 'string') {
        date = new Date(date);
    }

    if(type === 'unformated') {
        const options = { year: 'numeric',  day: 'numeric', month: 'numeric' };
        return date.toLocaleDateString(lang, options);
    }
    else {
        const dayName = new Intl.DateTimeFormat(lang, { weekday: 'long' }).format(date); // Get the weekday
        const day = date.getDate();
        const month = date.getMonth() + 1; // Months are zero-indexed
        const year = date.getFullYear();
        
        return `${dayName} ${day}.${month}.${year}`;
    }


};
const formatMemberType = (id) => {
    //const nameType = memberTypeNames.find(item => item.id === id)
    //return nameType['type_of_object'];
    return userTypes[id];
};

const getItem = async (data) => {
    try {        
        const response = await fetch('https://www.theclub.fi/booking/controler/bookings.php', {
            method: 'POST',
            mode: "cors", // no-cors, *cors, same-origin            
            body: JSON.stringify({
                ...data
            })
        });

        if (!response.ok) {
            throw new Error('Failed to fetch item');
        } 

        // If response is successful, return the response data
        const jsonData = await response.json();
        return jsonData; // Assuming the response is JSON data

    } catch (error) {
        console.error('Error saving item:', error);
    }
};
 
const sendEmail = async (data) => {
    try {        
        const response = await fetch('https://www.theclub.fi/booking/form-handler/form.php', {
            method: 'POST',
            mode: "cors", // no-cors, *cors, same-origin            
            body: JSON.stringify({
                ...data
            })
        });

        if (!response.ok) {
            throw new Error('Failed to save item');
        } 
        // else {
        //     // If the response is successful, navigate to a different page
        //     navigate('/success'); // Replace '/success' with the path to the success page
        // }
    } catch (error) {
        console.error('Error saving item:', error);
    }
};

const formatTimeName = (timeId) => {    
    const availableTimes = ["07:00–08:00","08:00–09:00","09:00–10:00","10:00–11:00","11:00–12:00","12:00–13:00","13:00–14:00","14:00–15:00","15:00–16:00","16:00–17:00","17:00–18:00","18:00–19:00","19:00–20:00","20:00–21:00","21:00–22:00","22:00–23:00","23:00–00:00","00:00–01:00"]

    return availableTimes[timeId]; 
}

const formatTableName = (tableId) => {    
    const availableTables = ["Pool 1","Pool 2","Pool 3","Pool 4","Pool 5","Pool 6","Pool 7","Pool 8","Pool 9","Pool 10","Pool 11","Snooker"];

    return availableTables[tableId];
}

function isSameOrAfterCurrentMonth(selectedDate,dateString) {
    if (!dateString || dateString === '0000-00-00' || typeof dateString !== 'string') {
        return false;
    }

    // Get current year and month
    const currentDate = new Date(selectedDate);
    if (isNaN(currentDate.getTime())) {
        return false;
    }
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // getMonth() is zero-based

    // Parse the input date string
    const parts = dateString.split("-").map(Number);
    if (parts.length < 2 || isNaN(parts[0]) || isNaN(parts[1]) || parts[0] === 0) {
        return false;
    }
    const [year, month] = parts;

    // Compare year and month
    if (year > currentYear) {
        return true;
    } else if (year === currentYear && month >= currentMonth) {
        return true;
    } else {
        return false;
    }
}

function formatBookingCreated(timestamp) {
    const [date, time] = timestamp.split(' ');
    const [year, month, day] = date.split('-');
    const [hours, minutes] = time.split(':');

    return `${day}.${month}.${year} kl. ${hours}:${minutes}`;
}

const toDateInputValue = (date) => {
    if (!date) return '';
    if (typeof date === 'string') {
        const trimmed = date.trim();
        if (trimmed.startsWith('0000-00-00')) return '';
        const match = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (match) {
            return `${match[1]}-${match[2]}-${match[3]}`;
        }
    }
    const d = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(d.getTime())) return '';
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const toMonthInputValue = (date) => {
    if (!date) return '';
    const d = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(d.getTime())) return '';
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
};

const fromDateInputValue = (dateString) => {
    if (!dateString || typeof dateString !== 'string') return null;
    const parts = dateString.split('-').map(Number);
    if (parts.length !== 3 || parts.some(isNaN)) return null;
    const [year, month, day] = parts;
    const result = new Date(year, month - 1, day);
    if (isNaN(result.getTime())) return null;
    return result;
};

const fromMonthInputValue = (monthString) => {
    if (!monthString || typeof monthString !== 'string') return null;
    const parts = monthString.split('-').map(Number);
    if (parts.length !== 2 || parts.some(isNaN)) return null;
    const [year, month] = parts;
    const result = new Date(year, month - 1, 1);
    if (isNaN(result.getTime())) return null;
    return result;
};

export {
    getItem,
    sendEmail,
    formatDate,
    formatShortDate,
    formatTimeName,
    formatTableName,
    formatMemberType,
    isSameOrAfterCurrentMonth,
    formatBookingCreated,
    toDateInputValue,
    toMonthInputValue,
    fromDateInputValue,
    fromMonthInputValue
}

